export default __webpack_public_path__ + "static/footer-bg-2-c30bc7c0d0cec80893a0fa0415e81bd3.jpg";